import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import { useDispatch } from 'react-redux'
import { hideLoading, showLoading } from '../redux store/loader'
import { Link } from 'react-router-dom'
import '../stylings/publicDisclosure.css'

const infoItems = [
  { icon: 'fa-solid fa-school',        label: 'School Name',              value: 'Vidya Jain Convent School' },
  { icon: 'fa-solid fa-id-card',       label: 'Affiliation No.',          value: '2730922' },
  { icon: 'fa-solid fa-location-dot',  label: 'Address',                  value: 'Khasra No.- 142, Plot - 289, Delhi - 110081' },
  { icon: 'fa-solid fa-compass',       label: 'Longitude & Latitude',     value: '28.7345° N, 77.0163° E' },
  { icon: 'fa-solid fa-user-tie',      label: 'Principal',                value: 'Mr. Naresh Kumar Jain' },
  { icon: 'fa-solid fa-envelope',      label: 'School E-mail',            value: 'vjconvent2004@gmail.com', lower: true },
  { icon: 'fa-solid fa-phone',         label: 'Contact',                  value: '9999740333' },
]

const docGroups = [
  {
    group: 'School Registration & Affiliation',
    icon: 'fa-solid fa-building-columns',
    color: '#1a3c72',
    docs: [
      { label: 'Education Department Certificate',        href: '/educational department folder.pdf',    icon: 'fa-solid fa-file-pdf' },
      { label: 'Section Extension Certificate',           href: '/doe section approval.pdf',             icon: 'fa-solid fa-file-pdf' },
      { label: 'Society Registration Certificate',        href: '/society registration certificate.pdf', icon: 'fa-solid fa-file-pdf' },
      { label: 'CBSE Affiliation Letter',                 href: '/cbse affiliation letter.pdf',          icon: 'fa-solid fa-file-pdf' },
      { label: 'Secondary School Certificate',            href: '/secondarySchoolCertificate.pdf',       icon: 'fa-solid fa-file-pdf' },
      { label: 'Recognition Letter Certificate (DOE)',    href: '/recognitionLetterCertificate.pdf',     icon: 'fa-solid fa-file-pdf' },
      { label: 'NOC by State Govt./UT',                   href: '/noc by gov.pdf',                       icon: 'fa-solid fa-file-pdf' },
    ],
  },
  {
    group: 'Safety & Infrastructure',
    icon: 'fa-solid fa-shield-halved',
    color: '#d97706',
    docs: [
      { label: 'Fire Safety Certificate',                 href: '/fire safety certificate.pdf',                        icon: 'fa-solid fa-fire-extinguisher' },
      { label: 'Health Certificate',                      href: '/health certificate.jpeg',                            icon: 'fa-solid fa-heart-pulse' },
      { label: 'School Health Certificate',               href: '/schoolHealthCertificate.pdf',                        icon: 'fa-solid fa-kit-medical' },
      { label: 'Valid Water, Health & Sanitation Certs',  href: '/valid water health and sanitation certificates.pdf', icon: 'fa-solid fa-droplet' },
      { label: 'Rain Water Harvesting Certificate',       href: '/rain water harvesting certificate.pdf',              icon: 'fa-solid fa-cloud-rain' },
      { label: 'Jal Board Certificate',                   href: '/water quality certificate.pdf',                      icon: 'fa-solid fa-faucet' },
      { label: 'Building Certificate',                    href: '/building safety certificate.pdf',                    icon: 'fa-solid fa-building' },
      { label: 'Structure Stability Certificate',         href: '/structuralStabilityCertificate.pdf',                 icon: 'fa-solid fa-helmet-safety' },
    ],
  },
  {
    group: 'Land & Property',
    icon: 'fa-solid fa-map',
    color: '#16a34a',
    docs: [
      { label: 'Deed Certificate',                        href: '/deed.pdf',                             icon: 'fa-solid fa-scroll' },
      { label: 'Certificate of Land',                     href: '/certifcateofland.jpeg',                icon: 'fa-solid fa-map-location-dot' },
      { label: 'Infrastructure Certificate',              href: '/list Of infrastructure certificate.pdf', icon: 'fa-solid fa-city' },
      { label: 'Room Details Info',                       href: '/roomdesription.pdf',                   icon: 'fa-solid fa-door-open' },
    ],
  },
  {
    group: 'Staff & Academic',
    icon: 'fa-solid fa-graduation-cap',
    color: '#7c3aed',
    docs: [
      { label: 'Teaching Staff List',                     href: '/teachingstaff.pdf',                    icon: 'fa-solid fa-chalkboard-user' },
      { label: 'Staff Statements 2025-26',                href: '/staffstatements2526.pdf',              icon: 'fa-solid fa-users' },
      { label: 'List of School Management Committee',     href: '/listOfManagementCertificate.pdf',      icon: 'fa-solid fa-people-group' },
      { label: 'PTA List',                                href: '/listofpta.pdf',                        icon: 'fa-solid fa-handshake' },
      { label: 'Academic Calendar 2025-26',               href: '/academiccalender2526.pdf',             icon: 'fa-solid fa-calendar-days' },
      { label: 'Fee Structure',                           href: '/feestructure.pdf',                     icon: 'fa-solid fa-indian-rupee-sign' },
      { label: 'Admission Criteria 2025-26',              href: '/admcrieteria2526.pdf',                 icon: 'fa-solid fa-clipboard-list' },
      { label: 'EWS Performa',                            href: '/ewsprofarma.pdf',                      icon: 'fa-solid fa-file-circle-check' },
      { label: 'Self Certification',                      href: '/self certification.pdf',               icon: 'fa-solid fa-certificate' },
    ],
  },
  {
    group: 'Videos',
    icon: 'fa-brands fa-youtube',
    color: '#dc2626',
    docs: [
      { label: 'School Inspection Video',  href: 'https://www.youtube.com/watch?v=ZrZJAq8L8i0', icon: 'fa-brands fa-youtube', isVideo: true },
      { label: 'Computer Lab Video',       href: 'https://www.youtube.com/watch?v=dk69OnOBMLY',  icon: 'fa-brands fa-youtube', isVideo: true },
    ],
  },
]

const PublicDisclosure = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(showLoading())
    setTimeout(() => { dispatch(hideLoading()) }, 1700)
  }, [])

  return (
    <Layout>
      <div className="pd-page">

        {/* ── Hero Banner ── */}
        <div className="pd-hero">
          <div className="pd-hero-blob pd-hero-blob--1" />
          <div className="pd-hero-blob pd-hero-blob--2" />
          <div className="container pd-hero-inner">
            <div className="pd-hero-badge">
              <i className="fa-solid fa-shield-halved"></i>
              CBSE Mandatory
            </div>
            <h1 className="pd-hero-title">Public Disclosure</h1>
            <p className="pd-hero-sub">
              All mandatory information as required by CBSE affiliation bylaws — transparently shared for students, parents and stakeholders.
            </p>
          </div>
        </div>

        <div className="container pd-body">

          {/* ── School Info Table ── */}
          <div className="pd-section">
            <div className="pd-section-head">
              <span className="pd-section-tag">
                <i className="fa-solid fa-circle-info"></i> School Information
              </span>
            </div>
            <div className="pd-info-table-wrap">
              <table className="pd-info-table">
                <tbody>
                  {infoItems.map((item, i) => (
                    <tr key={i} className="pd-info-row">
                      <td className="pd-info-th">
                        <div className="pd-info-th-inner">
                          <div className="pd-info-icon">
                            <i className={item.icon}></i>
                          </div>
                          <span>{item.label}</span>
                        </div>
                      </td>
                      <td className={`pd-info-td${item.lower ? ' pd-info-td--lower' : ''}`}>
                        {item.value}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── Document Groups ── */}
          {docGroups.map((group, gi) => (
            <div className="pd-section" key={gi}>
              <div className="pd-section-head">
                <span className="pd-section-tag" style={{ '--gc': group.color }}>
                  <i className={group.icon}></i> {group.group}
                </span>
                <span className="pd-section-count">{group.docs.length} documents</span>
              </div>
              <div className="pd-doc-grid">
                {group.docs.map((doc, di) => (
                  <Link
                    key={di}
                    to={doc.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="pd-doc-card"
                    style={{ '--gc': group.color }}
                  >
                    <div className="pd-doc-icon-wrap">
                      <i className={doc.icon}></i>
                    </div>
                    <span className="pd-doc-label">{doc.label}</span>
                    <div className="pd-doc-action">
                      <i className={doc.isVideo ? 'fa-solid fa-play' : 'fa-solid fa-download'}></i>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          ))}

        </div>
      </div>
    </Layout>
  )
}

export default PublicDisclosure
